import { Alert, Card, CardContent, Stack, Typography } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SessionCard from './SessionCard';
import { registrationStyles } from './eventDetailsStyles';
import { getSessionSeatsLeft, getSessionTickets, isSessionAvailable } from './eventDetailsUtils';

const RegistrationAvailability = ({
  sessions,
  eventTickets,
  hasAvailableSessions,
  isTicketSalesOpen,
  isSessionRegistrationOpen,
  shouldShowRemainingTickets = false,
  registrationUnavailableMessage,
  selectedSessionId,
  selectedTicketCode,
  selectedSession,
  selectedTicket,
  selectedTicketSeatsLeft,
  quantity,
  totalPrice,
  formErrors,
  onSessionSelect,
  onTicketSelect,
  onQuantityChange,
  getTicketQuantityLimit,
  onOpenRegistration,
}) => (
  <Card sx={registrationStyles.sectionCard}>
    <CardContent>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <EventAvailableIcon sx={registrationStyles.headerIcon} />
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Registration &amp; Availability</Typography>
      </Stack>


      {sessions.length === 0 && <Alert severity="info">No sessions are currently available for this event.</Alert>}
      {sessions.length > 0 && !hasAvailableSessions && (
        <Alert severity="warning" sx={registrationStyles.warning}>{registrationUnavailableMessage}</Alert>
      )}

      <Stack spacing={2}>
        {sessions.map((session) => {
          const isSelected = isTicketSalesOpen && String(selectedSessionId) === String(session.id);
          const sessionTicketTypes = getSessionTickets(session, eventTickets);
          const isAvailable = isTicketSalesOpen && isSessionRegistrationOpen(session) && isSessionAvailable(session, eventTickets);
          const summaryDisabled = !selectedSession || !selectedTicketCode || !hasAvailableSessions;
          const sessionAvailabilityLabel = !isTicketSalesOpen
            ? ''
            : !isAvailable
              ? 'Sold out'
              : shouldShowRemainingTickets
                ? `${getSessionSeatsLeft(session, eventTickets) ?? 'Limited'} seats left`
                : '';

          return (
            <SessionCard
              key={session.id}
              session={session}
              isSelected={isSelected}
              isAvailable={isAvailable}
              shouldShowRemainingTickets={shouldShowRemainingTickets}
              sessionAvailabilityLabel={sessionAvailabilityLabel}
              sessionTicketTypes={sessionTicketTypes}
              selectedTicketCode={selectedTicketCode}
              selectedTicket={selectedTicket}
              selectedTicketSeatsLeft={selectedTicketSeatsLeft}
              quantity={quantity}
              totalPrice={totalPrice}
              formErrors={formErrors}
              onSessionSelect={onSessionSelect}
              onTicketSelect={onTicketSelect}
              onQuantityChange={onQuantityChange}
              getTicketQuantityLimit={getTicketQuantityLimit}
              onOpenRegistration={onOpenRegistration}
              summaryDisabled={summaryDisabled}
            />
          );
        })}
      </Stack>
    </CardContent>
  </Card>
);

export default RegistrationAvailability;
